module.exports = __webpack_public_path__ + "static/img/zhuanli-2.9a478b5c.png";